<template>
  <div>
    <div v-if="$isDebug()" class="debug-container">
      <div>AD</div>
    </div>
    <div v-else class="public-container">
      <div id="adsense">
        <ins v-if="standby" class="adsbygoogle"
             style="display:block"
             :data-ad-client="adClient"
             :data-ad-slot="adSlot"
             data-ad-format="auto"
             data-full-width-responsive="true"></ins>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      standby: false,
      adClient: null,
      adSlot: null,
      adsbygoogle: 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js'
    };
  },
  mounted: function () {

    if (this.$isDebug()) {
      return;
    }

    this.adClient = process.env.VUE_APP_ADSENSE_CLIENT;
    this.adSlot = process.env.VUE_APP_ADSENSE_SLOT;

    console.log(this.adClient, this.adSlot);

    if (!this.adClient || !this.adSlot) {
      return;
    }

    this.standby = true;

    let el = document.getElementById('adsense');
    console.log(el);

    let script = document.createElement('script');
    script.setAttribute('src', this.adsbygoogle);
    el.appendChild(script);

    let script2 = document.createElement("script");
    let str = document.createTextNode('(adsbygoogle = window.adsbygoogle || []).push({}); console.log(\'adsense\');');
    script2.appendChild(str);

    setTimeout(function () {
      el.appendChild(script2);
    }, 200);

  },

};
</script>
<style lang="scss" scoped>

  @import '@/assets/styles/_variable.scss';

  // PC
  @media screen and (min-width: $mediaMinWidth) {
    .public-container {
      max-width: 800px;
      margin: 0 auto;
    }

    .debug-container {
      border: 1px solid #ddd;
      background: #fafafa;
      max-width: 700px;
      margin: 0 auto;
      width: 100%;
      height: 300px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #aaa;
      font-size: 20px;
    }
  }

  // SP
  @media screen and (max-width: $mediaMaxWidth) {
    .public-container {
      width: 100%;
    }

    .debug-container {
      border: 1px solid #ddd;
      background: #fafafa;
      height: 300px;
      width: 300px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #aaa;
      font-size: 20px;
    }
  }


</style>
